module.exports = __webpack_public_path__ + "static/media/panther-busd.bd6019a1.png";